// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._x3do1syp{border-top:var(--_10k8kuu)}._16jlidpf{flex-grow:0}\n._16qs2hsd{box-shadow:0 -1px 1px 0 var(--ds-border,rgba(0,0,0,.1))}\n._1o9zidpf{flex-shrink:0}\n._i0dl1wug{flex-basis:auto}", ""]);
// Exports
module.exports = exports;
